export const PAGE_SIZE = 5;
export const MODAL_AUTO_CLOSE_TIMEOUT = 5000;
export const REVIEW_ITEM_HEIGHT = 4.75; // rem
